module.exports = __webpack_public_path__ + "img/keep_it_100_ejuice_1.e94a47d0.png";